<div class="demographics-container">
  <div class="message-popup" *ngIf="!showNotificationPopup">
    <div class="title">{{messageTitle}}</div>
    <div>{{messageContent}}</div>
  </div>
  <div class="row">
    <div class="col-sm-6 justify-padding-right">
      <div class="chart-container">
        <achoo-pie-chart-placholder
          [title]="'INFLUENCER.CHART.GENDER' | translate"
          [list]="['Female', 'Male']">
        </achoo-pie-chart-placholder>
      </div>
    </div>
    <div class="col-sm-6 justify-padding-left">
      <div class="chart-container">
        <achoo-pie-chart-placholder
          [title]="'INFLUENCER.CHART.COUNTRIES' | translate"
          [list]="['Denmark', 'United States', 'Spain', 'Italy', 'France', 'Germany']">
        </achoo-pie-chart-placholder>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <div class="chart-container">
        <gender-per-age-chart
          [isPlaceholder]="true"
          [chartData]="[{'range': '13-17', 'm': 60, 'f': 60}, {'range': '18-24', 'm': 60, 'f': 60}, {'range': '25-34', 'm': 60, 'f': 60}, {'range': '35-44', 'm': 60, 'f': 60}]"
          [maxPercent]="80">
        </gender-per-age-chart>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6 justify-padding-right">
      <div class="chart-container">
        <achoo-pie-chart-placholder
          [title]="'INFLUENCER.CHART.AUDIENCE_INTERESTS' | translate"
          [list]="['Restaurants', 'Travel', 'Clothes, Shoes', 'Coffee, Tea', 'Phone, Camera', 'Friends']">
        </achoo-pie-chart-placholder>
      </div>
    </div>
    <div class="col-sm-6 justify-padding-left">
      <div class="chart-container">
        <achoo-pie-chart-placholder
          [title]="'INFLUENCER.CHART.NATIVE_LANGUAGES' | translate"
          [list]="['English', 'Danish', 'Chinese', 'German']">
        </achoo-pie-chart-placholder>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <div class="chart-container">
        <div class="title">{{'INFLUENCER.CHART.BRAND_AFFINITY' | translate}}</div>
        <div class="brand-list">
          <span class="badge brand placeholder" *ngFor="let item of arrayGenByNumber(15); let i = index" [ngClass]="{
                  'super-short-item': i % 6 === 0,
                  'normal-item': i % 6 === 1,
                  'long-item': i % 6 === 2,
                  'medium-item': i % 6 === 3,
                  'short-item': i % 6 === 4,
                  'huge-item': i % 6 === 5
                  }"></span>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/demographic-fallback/demographic-fallback.component.html